var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaybukInAct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.87 16.59H3.90999C2.41999 16.59 1.20999 15.38 1.20999 13.89V2.7C1.20999 1.21 2.41999 0 3.90999 0H11.86C13.35 0 14.56 1.21 14.56 2.7V13.89C14.56 15.38 13.35 16.59 11.86 16.59H11.87ZM3.90999 0.91C2.91999 0.91 2.11999 1.71 2.11999 2.7V13.89C2.11999 14.88 2.91999 15.68 3.90999 15.68H11.86C12.85 15.68 13.65 14.88 13.65 13.89V2.7C13.65 1.71 12.85 0.91 11.86 0.91H3.90999Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21 5.74001H0.29C0.13 5.74001 0 5.54001 0 5.28001C0 5.02001 0.13 4.82001 0.29 4.82001H3.22C3.38 4.82001 3.51 5.02001 3.51 5.28001C3.51 5.54001 3.38 5.74001 3.22 5.74001H3.21Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21 8.8H0.29C0.13 8.8 0 8.6 0 8.34C0 8.08 0.13 7.88 0.29 7.88H3.22C3.38 7.88 3.51 8.08 3.51 8.34C3.51 8.6 3.38 8.8 3.22 8.8H3.21Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21 11.85H0.29C0.13 11.85 0 11.65 0 11.39C0 11.13 0.13 10.93 0.29 10.93H3.22C3.38 10.93 3.51 11.13 3.51 11.39C3.51 11.65 3.38 11.85 3.22 11.85H3.21Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.69 7.18999L7.36999 5.26999C6.51999 4.77999 5.45999 5.38999 5.45999 6.36999V10.2C5.45999 11.18 6.51999 11.79 7.36999 11.3L10.69 9.37999C11.54 8.88999 11.54 7.66999 10.69 7.17999V7.18999Z",
    fill: "#33363F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 16.59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybukInAct1);
export default __webpack_public_path__ + "static/media/PlaybukInAct 1.3e00f26dfc96596f6a9fa8527ea384e6.svg";
export { ForwardRef as ReactComponent };